import React, { useContext } from 'react';
import AppListingContext from './components/AppListingContext';
import AppsGrid from './components/AppsGrid';
import CategorySection from './components/CategorySection';

const Listings = () => {
  const { appListings } = useContext(AppListingContext);

  return (
    <>
      <If condition={appListings.length > 0}>
        <AppsGrid apps={appListings} />
      </If>
      <If condition={appListings.length === 0}>
        <CategorySection categoryKey="featured" />
        <CategorySection categoryKey="most-popular" />
      </If>
    </>
  );
};

export default Listings;
